import React from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import How from "./How/How";

const HowWeWork = () => {
  return (
    <>
      <Header />
      <How />
      <Footer />
    </>
  );
};

export default HowWeWork;
